export default "__VITE_ASSET__jQFiXkXh__"